import { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, Copy } from "lucide-react";

export const Info = ({ label, value, mono, testid, copy }) => (
  <div className="min-w-0">
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className="flex items-center gap-1.5">
      <span data-testid={testid} title={typeof value === "string" ? value : undefined} className={`truncate text-sm text-slate-100 ${mono ? "font-mono" : ""}`}>{value ?? "—"}</span>
      {copy && value && (
        <button data-testid={`copy-${testid || label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => navigator.clipboard.writeText(String(value)).then(() => toast.success(`${label} copiado`))} className="text-slate-500 hover:text-white">
          <Copy className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  </div>
);

export const Secret = ({ label, value }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="min-w-0">
      <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="flex items-center gap-2">
        <span data-testid="client-password" className="font-mono text-sm text-slate-100">{value ? (show ? value : "••••••") : "—"}</span>
        {value && <>
          <button data-testid="toggle-password" onClick={() => setShow(!show)} className="text-slate-500 hover:text-white">
            {show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
          </button>
          <button data-testid="copy-password" onClick={() => { navigator.clipboard.writeText(value); toast.success("Senha copiada"); }} className="text-slate-500 hover:text-white">
            <Copy className="h-3.5 w-3.5" />
          </button>
        </>}
      </div>
    </div>
  );
};

export const InfoCard = ({ title, icon: Icon, color, children, testid }) => (
  <div data-testid={testid} className="rounded-xl border border-[#1F293D] bg-[#111827] p-4">
    <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
      <Icon className="h-3.5 w-3.5" style={{ color }} /> {title}
    </div>
    <div className="grid grid-cols-2 gap-x-4 gap-y-3">{children}</div>
  </div>
);
